export const ErrorCodes = {
  auth_refresh_failed: 'AuthRefreshFailedSessionExpired',
}
